/**
 * Arabic for the HR suite — the workforce, manpower cost, the labour cost of
 * work, Saudization and the Saudi labour rules. Proposed; pending review by
 * the airport's HR team.
 *
 * Terms follow the Saudi usage an HR officer meets on GOSI and Qiwa:
 * التأمينات الاجتماعية (GOSI), ساند (SANED), مكافأة نهاية الخدمة (end of
 * service), المقابل المالي (the levy), نطاقات (Nitaqat), السعودة. Labels shown
 * through t(variable) — trades, statuses, rule sources, nationalities — are
 * here too, since the extractor cannot see them.
 */
const ar: Record<string, string> = {
  HR: "الموارد البشرية",
  Workforce: "القوى العاملة",
  "Manpower cost": "تكلفة القوى العاملة",
  "Labour cost of work": "تكلفة العمالة على الأعمال",
  Saudization: "السعودة",
  "Saudi labour rules": "أنظمة العمل السعودية",
  "The workforce and what it costs under Saudi law: pay, GOSI, end of service, levy and fees, the hour of each trade, and Saudization.":
    "القوى العاملة وتكلفتها وفق النظام السعودي: الرواتب، والتأمينات الاجتماعية، ومكافأة نهاية الخدمة، والمقابل المالي والرسوم، وتكلفة ساعة كل تخصص، والسعودة.",
  "Who works at the airport, on what contract and pay, and what each person costs a month and an hour once GOSI, the end-of-service accrual, medical cover and, for non-Saudis, the levy and fees are added — computed from the Saudi labour rules, which are shown with their sources and can be restated.":
    "من يعمل في المطار، وبأي عقد وراتب، وكم يكلّف كل شخص في الشهر وفي الساعة بعد إضافة التأمينات الاجتماعية ومخصص مكافأة نهاية الخدمة والتأمين الطبي، وللعاملين غير السعوديين المقابل المالي والرسوم — محسوباً من أنظمة العمل السعودية المعروضة مع مصادرها والقابلة لإعادة التحديد.",
  "The hour is what links HR to the rest of the platform: a work order's labour hours are priced at the rate of the person who closed it, or of the trade that works on its asset, and Asset Management's preventive plans are priced for a year. The register's year is set against the Staff line of the finance figures, and Saudization is counted the way Nitaqat counts it.":
    "الساعة هي ما يربط الموارد البشرية ببقية المنصة: تُسعَّر ساعات العمل في أمر العمل بتكلفة الشخص الذي أغلقه، أو بتكلفة التخصص الذي يعمل على أصله، وتُسعَّر خطط الصيانة الوقائية في إدارة الأصول لسنة كاملة. وتُقارن سنة السجل ببند الموظفين في الأرقام المالية، وتُحسب السعودة كما يحسبها برنامج نطاقات.",
  "Everyone as photo cards or a table — nationality, department, trade, contract, hire date, monthly salary, GOSI schedule and platform user; click anyone to open their staff file, or add a new joiner in a window that shows their monthly cost as the salary is typed.":
    "الجميع بطاقات بالصور أو جدولاً — الجنسية والإدارة والتخصص والعقد وتاريخ التعيين والراتب الشهري وجدول التأمينات ومستخدم المنصة؛ انقر على أي شخص لفتح ملفه الوظيفي، أو أضف موظفاً جديداً في نافذة تُظهر تكلفته الشهرية أثناء إدخال الراتب.",
  "Each person's month — gross pay, employer GOSI, end-of-service accrual, medical, levy and fees or contract charge — and the loaded hourly and overtime rates; totals by department, trade and cost centre, the end of service owed today, overtime by month, and the register set against the finance figures' Staff line.":
    "شهر كل شخص — إجمالي الراتب، وحصة صاحب العمل في التأمينات، ومخصص نهاية الخدمة، والتأمين الطبي، والمقابل المالي والرسوم أو رسم المقاول — وتكلفة الساعة الكاملة وساعة العمل الإضافي؛ والإجماليات حسب الإدارة والتخصص ومركز التكلفة، ومكافأة نهاية الخدمة المستحقة اليوم، والعمل الإضافي حسب الشهر، ومقارنة السجل ببند الموظفين في الأرقام المالية.",
  "Work orders' labour hours priced at the doer's rate or their trade's, by month, trade, asset type and asset, with what could not be priced counted; and the preventive maintenance plans' labour for a year.":
    "ساعات العمل في أوامر العمل مسعّرة بتكلفة منفّذها أو تخصصه، حسب الشهر والتخصص ونوع الأصل والأصل، مع عدّ ما تعذّر تسعيره؛ وعمالة خطط الصيانة الوقائية لسنة.",
  "The Nitaqat share of the direct workforce against the airport's target, by department and nationality, the Saudi hires needed to reach it, the Saudis paid under the full-count wage, and a what-if.":
    "نسبة نطاقات في القوى العاملة المباشرة مقابل هدف المطار، حسب الإدارة والجنسية، وعدد السعوديين المطلوب توظيفهم لبلوغه، والسعوديون الذين تقل أجورهم عن حد الاحتساب الكامل، وسيناريو ماذا لو.",
  "The GOSI, SANED, end-of-service, leave, hours, overtime, levy, fee and Nitaqat rules the suite computes with, each with its article or scheme, restatable by the airport; the new-entrant GOSI schedule; and an end-of-service calculator.":
    "قواعد التأمينات وساند ونهاية الخدمة والإجازات وساعات العمل والعمل الإضافي والمقابل المالي والرسوم ونطاقات التي تحسب بها المجموعة، كلٌّ مع مادته أو برنامجه، وقابلة لإعادة التحديد من المطار؛ وجدول التأمينات للمشتركين الجدد؛ وحاسبة مكافأة نهاية الخدمة.",
  "Sample workforce.": "قوى عاملة تجريبية.",
  "These are the demonstration's people and pay, not the airport's staff. On the platform the register starts empty and is filled by HR, by hand or from the payroll.":
    "هؤلاء أشخاص العرض التوضيحي ورواتبهم، لا موظفو المطار. على المنصة يبدأ السجل فارغاً وتملؤه الموارد البشرية يدوياً أو من مسير الرواتب.",
  "Pay is personal data": "الرواتب بيانات شخصية",
  "Your role does not hold hr:read. The HR officer, the administrator, the accountable manager and the project sponsor can read the workforce and its cost; an administrator grants the role on the Administration screen.":
    "دورك لا يملك صلاحية hr:read. يستطيع مسؤول الموارد البشرية ومدير النظام والمدير المسؤول وراعي المشروع الاطلاع على القوى العاملة وتكلفتها؛ ويمنح مدير النظام الدور من شاشة الإدارة.",
  "Rates: the published defaults, proposed until HR confirms them against GOSI, Qiwa and the Ministry.":
    "المعدلات: القيم المنشورة الافتراضية، مقترحة حتى تؤكدها الموارد البشرية مع التأمينات الاجتماعية وقوى والوزارة.",
  "Rates: as restated by this airport on the rules screen.": "المعدلات: كما أعاد المطار تحديدها في شاشة الأنظمة.",
  "An employee number is needed.": "رقم الموظف مطلوب.",
  "This employee number is already used.": "رقم الموظف هذا مستخدم من قبل.",
  "A two-letter country code, e.g. SA.": "رمز الدولة من حرفين، مثل SA.",
  "The hire date is needed; service, leave and end of service run from it.":
    "تاريخ التعيين مطلوب؛ فمنه تُحسب الخدمة والإجازة ونهاية الخدمة.",
  "A leaver needs the date they left.": "من ترك العمل يلزم تاريخ تركه.",
  "They cannot leave before they were hired.": "لا يمكن ترك العمل قبل التعيين.",
  "Between 1 and 72 hours.": "بين 1 و72 ساعة.",
  "That user is already bound to {no}.": "هذا المستخدم مرتبط من قبل بالموظف {no}.",
  "Add an employee": "إضافة موظف",
  "Edit {name}": "تعديل {name}",
  Who: "من",
  "Direct employee": "موظف مباشر",
  "Outsourced (contractor's head)": "عمالة مقاول (على كفالة المقاول)",
  Indefinite: "غير محدد المدة",
  "Fixed term": "محدد المدة",
  "What the contractor charges": "ما يتقاضاه المقاول",
  "An outsourced head costs what the contract charges; GOSI, end of service, the levy and the fees are the contractor's. Nor does it count toward this airport's Nitaqat.":
    "تكلفة عامل المقاول هي ما يتقاضاه العقد؛ أما التأمينات ونهاية الخدمة والمقابل المالي والرسوم فعلى المقاول. ولا يُحتسب ضمن نطاقات هذا المطار.",
  "Monthly pay (SAR)": "الراتب الشهري (ريال)",
  "Not recorded — assume from the hire date": "غير مسجل — يُفترض من تاريخ التعيين",
  "Yes — the 2024 schedule": "نعم — جدول 2024",
  "No — registered before": "لا — مسجل قبل ذلك",
  "Where the cost goes": "أين تذهب التكلفة",
  "Not bound": "غير مرتبط",
  "e.g. CC-AFM": "مثال: CC-AFM",
  "This makes {month} a month to the airport and {hour} an hour of work.":
    "هذا يكلّف المطار {month} في الشهر و{hour} لكل ساعة عمل.",
  "GOSI {pct}% ({regime}), end of service {eosb} a month, overtime {ot} an hour.":
    "التأمينات {pct}% ({regime})، ونهاية الخدمة {eosb} شهرياً، والعمل الإضافي {ot} للساعة.",
  "No pay entered yet: this person will be counted but not costed.":
    "لم يُدخل راتب بعد: سيُعدّ هذا الشخص دون أن تُحسب تكلفته.",
  "Add the employee": "أضف الموظف",
  "Job title": "المسمى الوظيفي",
  Grade: "الدرجة",
  Employment: "نوع التوظيف",
  "Contract ends": "ينتهي العقد",
  "Left on": "تاريخ ترك العمل",
  "Contracted hours a week": "ساعات العقد في الأسبوع",
  "Monthly charge for this head (SAR)": "الرسم الشهري لهذا العامل (ريال)",
  Basic: "الأساسي",
  Transport: "النقل",
  "Other fixed allowances": "بدلات ثابتة أخرى",
  "Medical premium a year (blank: the default)": "قسط التأمين الطبي السنوي (فارغ: القيمة الافتراضية)",
  "First registered with GOSI on or after 3 July 2024": "أول تسجيل في التأمينات في 3 يوليو 2024 أو بعده",
  "Platform user (who closes their work orders)": "مستخدم المنصة (من يغلق أوامر عمله)",
  "Cost centre": "مركز التكلفة",
  "{n} people on the register now: {d} direct employees and {o} outsourced.":
    "{n} شخصاً في السجل الآن: {d} موظفاً مباشراً و{o} من عمالة المقاولين.",
  "{s} of the direct employees are Saudi.": "{s} من الموظفين المباشرين سعوديون.",
  "{b} are bound to a platform user, so the work they close is priced at their own rate.":
    "{b} مرتبطون بمستخدم على المنصة، فتُسعَّر الأعمال التي يغلقونها بتكلفتهم هم.",
  "What does the workforce cost?": "كم تكلّف القوى العاملة؟",
  "Where are we on Saudization?": "أين نحن من السعودة؟",
  "On the register now": "في السجل الآن",
  "{d} direct · {o} outsourced": "{d} مباشر · {o} عمالة مقاول",
  "Saudi direct employees": "الموظفون المباشرون السعوديون",
  "{p}% of direct heads": "{p}% من الموظفين المباشرين",
  "Bound to a platform user": "مرتبطون بمستخدم على المنصة",
  "their jobs are priced at their own rate": "تُسعَّر أعمالهم بتكلفتهم هم",
  "Counted, not costed": "معدودون دون تكلفة",
  "no pay or contract charge entered": "لم يُدخل راتب ولا رسم مقاول",
  "have pay or a contract charge": "لديهم راتب أو رسم مقاول",
  "are bound to a platform user": "مرتبطون بمستخدم على المنصة",
  "Click a person to see or change their record.": "انقر على شخص لعرض سجله أو تعديله.",
  "All departments": "كل الإدارات",
  "Name, number or title": "الاسم أو الرقم أو المسمى",
  "Nobody is on the register yet. Add the workforce here, one by one, or ask for the payroll export to be loaded.":
    "لا أحد في السجل بعد. أضف القوى العاملة هنا واحداً تلو الآخر، أو اطلب تحميل ملف مسير الرواتب.",
  "Nobody matches.": "لا أحد يطابق.",
  "No.": "الرقم",
  Nationality: "الجنسية",
  Service: "الخدمة",
  "Monthly pay": "الراتب الشهري",
  GOSI: "التأمينات",
  "Platform user": "مستخدم المنصة",
  outsourced: "عمالة مقاول",
  "{y} y": "{y} سنة",
  "contractor's": "على المقاول",
  "hazards only": "الأخطار المهنية فقط",
  "* GOSI schedule assumed from the hire date; record the first registration date on the person to be sure.":
    "* جدول التأمينات مفترض من تاريخ التعيين؛ سجّل تاريخ أول تسجيل على الشخص للتأكد.",
  "You can read this record; changing it needs hr:write.": "يمكنك قراءة هذا السجل؛ وتعديله يتطلب صلاحية hr:write.",
  "Employee number": "رقم الموظف",
  "Hired on": "تاريخ التعيين",
  "Everyone current": "كل الحاليين",
  Direct: "مباشر",
  Leavers: "من تركوا العمل",
  "The workforce costs {m} a month, {y} a year, for {n} people.":
    "تكلّف القوى العاملة {m} في الشهر و{y} في السنة، لعدد {n} شخصاً.",
  "Of that, GOSI is {g} a month and the end-of-service accrual {e}; the end-of-service owed today is {l}.":
    "منها التأمينات {g} شهرياً ومخصص نهاية الخدمة {e}؛ ومكافأة نهاية الخدمة المستحقة اليوم {l}.",
  "Overtime over the last twelve months: {h} hours, {c}.":
    "العمل الإضافي خلال الاثني عشر شهراً الماضية: {h} ساعة، {c}.",
  "Which department costs most?": "أي إدارة هي الأعلى تكلفة؟",
  "What does an hour of each trade cost?": "كم تكلّف ساعة كل تخصص؟",
  "A month": "في الشهر",
  "{n} people costed": "{n} شخصاً محسوبة تكلفتهم",
  "A year": "في السنة",
  "before overtime": "قبل العمل الإضافي",
  "An hour, on average": "الساعة، في المتوسط",
  "fully loaded, over the hours actually worked": "بالتكلفة الكاملة، على الساعات المعمولة فعلاً",
  "End of service owed today": "نهاية الخدمة المستحقة اليوم",
  "if every direct employee left now (art. 84)": "لو ترك كل موظف مباشر العمل الآن (المادة 84)",
  "Overtime, 12 months": "العمل الإضافي، 12 شهراً",
  "{h} hours": "{h} ساعة",
  "Nobody is on the register yet, so nothing can be costed. Start on the Workforce screen.":
    "لا أحد في السجل بعد، فلا يمكن حساب أي تكلفة. ابدأ من شاشة القوى العاملة.",
  "Against the finance figures": "مقارنة بالأرقام المالية",
  "The Staff line is the demonstration's until the finance system's figures are connected or entered.":
    "بند الموظفين هو بند العرض التوضيحي حتى تُربط أرقام النظام المالي أو تُدخل.",
  "The Staff line of the finance figures, {period}.": "بند الموظفين في الأرقام المالية، {period}.",
  "Staff cost in the finance figures, a year": "تكلفة الموظفين في الأرقام المالية، سنوياً",
  "year to date {v}, annualised": "منذ بداية السنة {v}، محوّلة لسنة كاملة",
  "The register, a year": "السجل، سنوياً",
  "The register covers": "يغطي السجل",
  "— the rest is people or costs not on the register yet (other departments, bonuses, training).":
    "— والباقي أشخاص أو تكاليف ليست في السجل بعد (إدارات أخرى، مكافآت، تدريب).",
  "— more than the ledger: check the register for leavers still marked current.":
    "— أكثر من الدفاتر: راجع السجل بحثاً عمّن ترك العمل وما زال مسجلاً حالياً.",
  "Gross pay": "إجمالي الراتب",
  "GOSI (employer)": "التأمينات (صاحب العمل)",
  "End of service": "نهاية الخدمة",
  "Levy and fees": "المقابل المالي والرسوم",
  Outsourced: "عمالة المقاولين",
  "A month's cost, by what it is made of": "تكلفة الشهر حسب مكوّناتها",
  "Everything the airport pays for its people in a month, before overtime.":
    "كل ما يدفعه المطار لأفراده في شهر، قبل العمل الإضافي.",
  Part: "المكوّن",
  Share: "النسبة",
  "The hourly rate here is what the labour screen prices a trade's work at when the doer is not known.":
    "تكلفة الساعة هنا هي ما تسعّر به شاشة العمالة أعمال التخصص حين لا يُعرف المنفّذ.",
  "Each person": "كل شخص",
  "A month of each, part by part, and the hour it makes.": "شهر كل شخص، مكوّناً مكوّناً، وتكلفة الساعة الناتجة.",
  Gross: "الإجمالي",
  "Levy / contract": "المقابل المالي / المقاول",
  "An hour": "الساعة",
  "Overtime hour": "ساعة العمل الإضافي",
  "not costed": "غير محسوب التكلفة",
  "Overtime by month": "العمل الإضافي حسب الشهر",
  "Priced at each person's art. 107 rate: the hour's wage plus half the hour's basic.":
    "مسعّر بمعدل المادة 107 لكل شخص: أجر الساعة مضافاً إليه نصف أجر الساعة الأساسي.",
  "Who works the most overtime": "من يعمل أكثر ساعات إضافية",
  "No overtime recorded in the last twelve months.": "لا عمل إضافي مسجل خلال الاثني عشر شهراً الماضية.",
  "Record overtime": "تسجيل عمل إضافي",
  "One person, one month; entering 0 removes it.": "شخص واحد، شهر واحد؛ إدخال 0 يحذفه.",
  "Recorded: {h} hours in {m}.": "تم التسجيل: {h} ساعة في {m}.",
  "Choose a person": "اختر شخصاً",
  "Cost views": "عروض التكلفة",
  "By cost centre": "حسب مركز التكلفة",
  "What it is made of": "مكوّناتها",
  Overtime: "العمل الإضافي",
  "Labour on the work of the last {m} months: {h} hours, {c}.": "العمالة على أعمال آخر {m} شهراً: {h} ساعة، {c}.",
  "{p} of {w} work orders with hours are priced — {a} at the doer's own rate, {b} at their trade's.":
    "{p} من {w} أوامر عمل ذات ساعات مسعّرة — {a} بتكلفة المنفّذ نفسه، و{b} بتكلفة تخصصه.",
  "The preventive plans need {h} hours a year, {c} of labour.":
    "تحتاج الخطط الوقائية {h} ساعة سنوياً، بتكلفة عمالة {c}.",
  "Which assets cost most in labour?": "أي الأصول هي الأعلى تكلفة عمالة؟",
  "What does preventive maintenance cost in labour?": "كم تكلّف الصيانة الوقائية من العمالة؟",
  "Labour on work, {m} months": "العمالة على الأعمال، {m} شهراً",
  "{h} hours priced": "{h} ساعة مسعّرة",
  "Work orders priced": "أوامر العمل المسعّرة",
  "{a} by the doer, {b} by the trade": "{a} بالمنفّذ، و{b} بالتخصص",
  "Closed without hours": "أُغلقت دون ساعات",
  "of {n} work orders": "من {n} أمر عمل",
  "Preventive plans, a year": "الخطط الوقائية، سنوياً",
  "{h} hours of labour": "{h} ساعة عمل",
  "of the work orders record labour hours": "من أوامر العمل تسجّل ساعات عمل",
  "of those are priced at the doer's own rate": "منها مسعّرة بتكلفة المنفّذ نفسه",
  "of those are priced at a trade's rate": "منها مسعّرة بتكلفة تخصص",
  "No work order is priced at its doer's rate yet: none names a platform user bound to an employee. Bind each technician to their user on the Workforce screen, and have work orders closed under their own sign-in.":
    "لا يوجد أمر عمل مسعّر بتكلفة منفّذه بعد: لا يذكر أيٌّ منها مستخدماً مرتبطاً بموظف. اربط كل فني بمستخدمه في شاشة القوى العاملة، واجعل أوامر العمل تُغلق بتسجيل دخوله هو.",
  "Labour cost by month": "تكلفة العمالة حسب الشهر",
  "The priced work orders, by the month they were completed.": "أوامر العمل المسعّرة، حسب شهر إنجازها.",
  "No work order in the period could be priced.": "تعذّر تسعير أي أمر عمل في هذه الفترة.",
  "Labour by trade": "العمالة حسب التخصص",
  "Nothing priced yet.": "لم يُسعَّر شيء بعد.",
  "What an hour of each trade costs": "تكلفة ساعة كل تخصص",
  "The mean of the costed people in the trade, from Manpower cost.":
    "متوسط الأشخاص المحسوبة تكلفتهم في التخصص، من تكلفة القوى العاملة.",
  "No trade has a costed person yet.": "لا يوجد تخصص فيه شخص محسوبة تكلفته بعد.",
  "Labour by asset type": "العمالة حسب نوع الأصل",
  "Which kinds of asset take the most of the workforce's time.": "أي أنواع الأصول تستهلك معظم وقت القوى العاملة.",
  "No asset named": "دون أصل محدد",
  "The assets that cost most in labour": "الأصول الأعلى تكلفة عمالة",
  "Open one to see its work, defects and lifecycle in Asset Management.":
    "افتح أحدها لرؤية أعماله وعيوبه ودورة حياته في إدارة الأصول.",
  "No priced work order names an asset yet.": "لا يذكر أي أمر عمل مسعّر أصلاً بعد.",
  "Labour cost": "تكلفة العمالة",
  "Work orders with labour hours": "أوامر العمل ذات ساعات العمل",
  "The latest two hundred, with the rate each was priced at and why.":
    "آخر مئتين، مع المعدل الذي سُعّر به كلٌّ منها وسببه.",
  "No work order in the period records labour hours.": "لا يسجّل أي أمر عمل في الفترة ساعات عمل.",
  "Done by": "المنفّذ",
  Rate: "المعدل",
  "Priced by": "سُعّر حسب",
  "the doer": "المنفّذ",
  "{trade} trade": "تخصص {trade}",
  "cannot be priced": "تعذّر التسعير",
  "Preventive plans, a year of labour": "الخطط الوقائية، عمالة سنة",
  "Each plan's estimated hours, times how often it falls due, times its trade's hourly cost.":
    "الساعات المقدّرة لكل خطة، مضروبة في عدد مرات استحقاقها، مضروبة في تكلفة ساعة تخصصها.",
  "No active maintenance plan yet. Plans are made in Asset Management.":
    "لا توجد خطة صيانة نشطة بعد. تُنشأ الخطط في إدارة الأصول.",
  "{n} plans cannot be priced: no estimated hours, no interval, or no costed person in the trade.":
    "{n} خطط يتعذّر تسعيرها: دون ساعات مقدّرة أو فاصل زمني أو شخص محسوبة تكلفته في التخصص.",
  "Hours each": "الساعات لكل مرة",
  "Times a year": "مرات في السنة",
  "Hours a year": "الساعات في السنة",
  "Labour views": "عروض العمالة",
  "By month": "حسب الشهر",
  "By trade": "حسب التخصص",
  "By asset type": "حسب نوع الأصل",
  "No direct employee is on the register yet.": "لا يوجد موظف مباشر في السجل بعد.",
  "Saudization stands at {p} of the direct workforce ({c} Saudis counted, {e} non-Saudis).":
    "تبلغ السعودة {p} من القوى العاملة المباشرة ({c} سعوديون محتسبون، و{e} غير سعوديين).",
  "No Nitaqat target has been entered; enter it from Qiwa on the rules screen.":
    "لم يُدخل هدف نطاقات بعد؛ أدخله من منصة قوى في شاشة الأنظمة.",
  "Reaching the {tgt} target takes {n} more Saudis counted in full.":
    "بلوغ هدف {tgt} يتطلب {n} سعوديين إضافيين محتسبين بالكامل.",
  "The {tgt} target is met.": "تحقق هدف {tgt}.",
  "{n} Saudis are paid under the full-count wage.": "{n} سعوديين أجورهم أقل من حد الاحتساب الكامل.",
  "How many Saudis must we hire?": "كم سعودياً يجب أن نوظف؟",
  "Which department is lowest?": "أي إدارة هي الأدنى؟",
  "Saudization (Nitaqat)": "السعودة (نطاقات)",
  "target {tgt}": "الهدف {tgt}",
  "Saudis counted": "السعوديون المحتسبون",
  "{n} Saudi direct employees": "{n} موظفين مباشرين سعوديين",
  "Non-Saudi direct employees": "الموظفون المباشرون غير السعوديين",
  "Saudi hires to the target": "توظيف سعوديين حتى الهدف",
  "enter the target first": "أدخل الهدف أولاً",
  "counted in full, nobody leaving": "محتسبون بالكامل، دون مغادرة أحد",
  "{n} outsourced heads are not counted here: they count toward their contractor's Nitaqat, not the airport's.":
    "{n} من عمالة المقاولين لا يُحتسبون هنا: فهم يُحتسبون في نطاقات مقاولهم لا المطار.",
  "Nationality mix": "توزيع الجنسيات",
  "Direct employees, by nationality.": "الموظفون المباشرون حسب الجنسية.",
  "Where the airport stands": "أين يقف المطار",
  "Enter the airport's Nitaqat target from Qiwa to see the gap.": "أدخل هدف نطاقات للمطار من منصة قوى لرؤية الفجوة.",
  "{gap} points below the target.": "{gap} نقطة دون الهدف.",
  "At or above the target.": "عند الهدف أو فوقه.",
  "Saudis hired at the full-count wage, and non-Saudi contracts not renewed. Nothing is saved.":
    "سعوديون يُوظَّفون بأجر الاحتساب الكامل، وعقود غير سعوديين لا تُجدَّد. لا يُحفظ شيء.",
  "Saudization would be": "ستبلغ السعودة",
  "Non-Saudis": "غير السعوديين",
  "Saudis under the full-count wage": "سعوديون دون أجر الاحتساب الكامل",
  "Counted {full} and above in full, {half} and above as half (basic + housing).":
    "يُحتسب من {full} فأكثر كاملاً، ومن {half} فأكثر نصفاً (الأساسي + السكن).",
  "Every Saudi on the register counts in full.": "كل سعودي في السجل يُحتسب كاملاً.",
  "Basic + housing": "الأساسي + السكن",
  "Counts as": "يُحتسب",
  "Raise to count in full": "الزيادة اللازمة للاحتساب الكامل",
  "Saudis hired": "السعوديون الموظَّفون",
  "Non-Saudi contracts not renewed": "عقود غير السعوديين غير المجدَّدة",
  "The published defaults are in force, proposed until HR confirms them.":
    "القيم المنشورة الافتراضية سارية، مقترحة حتى تؤكدها الموارد البشرية.",
  "The airport has restated some rules; the rest are the published defaults.":
    "أعاد المطار تحديد بعض القواعد؛ والباقي هو القيم المنشورة الافتراضية.",
  "GOSI for a Saudi registered before July 2024: employer {er}%, employee {ee}%.":
    "التأمينات للسعودي المسجل قبل يوليو 2024: صاحب العمل {er}%، والموظف {ee}%.",
  "End of service: {a} of a month's wage a year for {y} years, then {b}.":
    "نهاية الخدمة: {a} من أجر شهر عن كل سنة لمدة {y} سنوات، ثم {b}.",
  "What is an employee's end of service?": "كم مكافأة نهاية خدمة الموظف؟",
  "What does GOSI cost us?": "كم تكلّفنا التأمينات؟",
  "These rates were written from the published law and schemes as understood on {date}. HR or legal should confirm each against GOSI, Qiwa and the Ministry of Human Resources before the costs are relied on.":
    "كُتبت هذه المعدلات من الأنظمة والبرامج المنشورة كما فُهمت في {date}. ينبغي للموارد البشرية أو الشؤون القانونية تأكيد كلٍّ منها مع التأمينات الاجتماعية وقوى ووزارة الموارد البشرية قبل الاعتماد على التكاليف.",
  "Restated by {by} on {at}.": "أعاد تحديدها {by} في {at}.",
  someone: "شخص ما",
  "Where each rule comes from": "مصدر كل قاعدة",
  law: "نظام",
  practice: "ممارسة",
  "The rates in force": "المعدلات السارية",
  "Change a figure and save; a figure left at its default stays the default.":
    "غيّر رقماً واحفظ؛ الرقم المتروك على قيمته الافتراضية يبقى افتراضياً.",
  "Changing the rules needs hr:write.": "تغيير القواعد يتطلب صلاحية hr:write.",
  "default {v}": "الافتراضي {v}",
  "The actual wage: basic and every fixed allowance (art. 2)": "الأجر الفعلي: الأساسي وكل بدل ثابت (المادة 2)",
  "Basic and housing only (where the contract says so)": "الأساسي والسكن فقط (حيث ينص العقد على ذلك)",
  "Every rate is a number, not negative.": "كل معدل رقم غير سالب.",
  "Saved. Every HR figure is re-priced with these rules.":
    "تم الحفظ. أُعيد تسعير كل أرقام الموارد البشرية بهذه القواعد.",
  "Save the rules": "احفظ القواعد",
  "Return to the published defaults": "العودة إلى القيم المنشورة الافتراضية",
  "GOSI annuities for new entrants": "معاشات التأمينات للمشتركين الجدد",
  "Saudis first registered on or after {d} pay a rising annuity rate; SANED and hazards are added on top.":
    "السعوديون المسجلون لأول مرة في {d} أو بعده يدفعون نسبة معاشات متصاعدة؛ ويُضاف إليها ساند والأخطار المهنية.",
  Employer: "صاحب العمل",
  Employee: "الموظف",
  "in force": "سارية",
  "End-of-service calculator": "حاسبة مكافأة نهاية الخدمة",
  "Labour Law arts. 84 and 85, with the rules above.": "المادتان 84 و85 من نظام العمل، بالقواعد أعلاه.",
  "Any wage and service": "أي أجر وأي مدة خدمة",
  "Ended by the employer": "إنهاء من صاحب العمل",
  "Fixed-term contract ended": "انتهاء العقد محدد المدة",
  Resignation: "استقالة",
  "First {y} years × {m} month's wage": "أول {y} سنوات × {m} من أجر شهر",
  "Then {y} years × {m} month's wage": "ثم {y} سنوات × {m} من أجر شهر",
  "The full award (art. 84)": "المكافأة الكاملة (المادة 84)",
  "Kept on resignation (art. 85)": "ما يُستحق عند الاستقالة (المادة 85)",
  "{f} of it": "{f} منها",
  Payable: "المستحق",
  "Wage the award is paid on": "الأجر الذي تُحسب عليه المكافأة",
  "Employee (optional)": "الموظف (اختياري)",
  "Monthly wage the award is paid on (SAR)": "الأجر الشهري الذي تُحسب عليه المكافأة (ريال)",
  "Years of service": "سنوات الخدمة",
  "How the service ends": "كيف تنتهي الخدمة",
  "Annuities, employer (registered before July 2024)": "المعاشات، صاحب العمل (المسجلون قبل يوليو 2024)",
  "Annuities, employee (registered before July 2024)": "المعاشات، الموظف (المسجلون قبل يوليو 2024)",
  "SANED, employer": "ساند، صاحب العمل",
  "SANED, employee": "ساند، الموظف",
  "Occupational hazards, employer": "الأخطار المهنية، صاحب العمل",
  "Contribution wage, floor": "أجر الاشتراك، الحد الأدنى",
  "Contribution wage, cap": "أجر الاشتراك، الحد الأعلى",
  SAR: "ريال",
  "Years at the lower rate": "السنوات بالمعدل الأدنى",
  "Lower rate, months of wage a year": "المعدل الأدنى، أشهر أجر عن كل سنة",
  months: "أشهر",
  "Later rate, months of wage a year": "المعدل اللاحق، أشهر أجر عن كل سنة",
  "Leave and hours": "الإجازات وساعات العمل",
  "Annual leave": "الإجازة السنوية",
  "Annual leave after the qualifying years": "الإجازة السنوية بعد سنوات الاستحقاق",
  "Qualifying years": "سنوات الاستحقاق",
  "Hours a week, most": "ساعات الأسبوع، الحد الأقصى",
  hours: "ساعات",
  "Working days a week": "أيام العمل في الأسبوع",
  "Public holidays a year": "العطل الرسمية في السنة",
  "Sick days allowed for": "أيام المرض المحسوبة",
  "Overtime premium, share of the hourly basic": "علاوة العمل الإضافي، نسبة من أجر الساعة الأساسي",
  "Non-Saudi staff": "الموظفون غير السعوديين",
  "Work-permit levy, a month": "المقابل المالي لرخصة العمل، شهرياً",
  "Iqama, a year": "الإقامة، سنوياً",
  "Work permit, a year": "رخصة العمل، سنوياً",
  "Exit/re-entry, a year": "تأشيرة الخروج والعودة، سنوياً",
  "Annual ticket (contract)": "تذكرة سنوية (بموجب العقد)",
  "Medical and Nitaqat": "التأمين الطبي ونطاقات",
  "Medical premium a year, when not on the person": "قسط التأمين الطبي السنوي، إن لم يُسجل على الشخص",
  "A Saudi counts in full from": "يُحتسب السعودي كاملاً من",
  "A Saudi counts as half from": "يُحتسب السعودي نصفاً من",
  "The airport's Nitaqat target (from Qiwa)": "هدف نطاقات للمطار (من منصة قوى)",
  Conveyance: "أنظمة النقل والسيور",
  "Systems (ICT, security, screening)": "الأنظمة (تقنية المعلومات، الأمن، التفتيش)",
  "Fire and life safety": "الحريق وسلامة الأرواح",
  "On leave": "في إجازة",
  Left: "ترك العمل",
  "Saudi Arabia": "المملكة العربية السعودية",
  Egypt: "مصر",
  India: "الهند",
  Pakistan: "باكستان",
  Bangladesh: "بنغلاديش",
  Philippines: "الفلبين",
  Jordan: "الأردن",
  Sudan: "السودان",
  Yemen: "اليمن",
  Nepal: "نيبال",
  "Sri Lanka": "سريلانكا",
  "United Kingdom": "المملكة المتحدة",
  "new entrant": "مشترك جديد",
  legacy: "قديم",
  "non-Saudi": "غير سعودي",
  recorded: "مسجل",
  "assumed from hire date": "مفترض من تاريخ التعيين",
  "GOSI contributions on basic + housing, floored at SAR 1,500 and capped at SAR 45,000":
    "اشتراكات التأمينات على الأساسي + السكن، بحد أدنى 1,500 ريال وحد أعلى 45,000 ريال",
  "Social Insurance Law (Royal Decree M/273), in force 3 July 2024":
    "نظام التأمينات الاجتماعية (المرسوم الملكي م/273)، النافذ في 3 يوليو 2024",
  "New entrants' annuity rate rises half a point a side each July to 11%":
    "نسبة معاشات المشتركين الجدد ترتفع نصف نقطة لكل طرف كل يوليو حتى 11%",
  "Social Insurance Law, transitional schedule for those first registered from 3 July 2024":
    "نظام التأمينات الاجتماعية، الجدول الانتقالي للمسجلين لأول مرة من 3 يوليو 2024",
  "SANED unemployment insurance, 0.75% employer and 0.75% employee, Saudis only":
    "تأمين ساند ضد التعطل، 0.75% على صاحب العمل و0.75% على الموظف، للسعوديين فقط",
  "Unemployment Insurance (SANED) Law": "نظام التأمين ضد التعطل عن العمل (ساند)",
  "Occupational hazards, 2% employer, every employee": "الأخطار المهنية، 2% على صاحب العمل، لكل موظف",
  "Social Insurance Law, occupational hazards branch": "نظام التأمينات الاجتماعية، فرع الأخطار المهنية",
  "End of service: half a month's wage a year for the first five years, a month's wage a year after":
    "نهاية الخدمة: أجر نصف شهر عن كل سنة من السنوات الخمس الأولى، وأجر شهر عن كل سنة بعدها",
  "Labour Law, article 84": "نظام العمل، المادة 84",
  "On resignation: nothing under 2 years, a third from 2 to 5, two thirds from 5 to 10, all after 10":
    "عند الاستقالة: لا شيء دون سنتين، والثلث من 2 إلى 5، والثلثان من 5 إلى 10، وكامل المكافأة بعد 10",
  "Labour Law, article 85": "نظام العمل، المادة 85",
  "Annual leave of 21 days, 30 after five years with the employer":
    "إجازة سنوية 21 يوماً، و30 يوماً بعد خمس سنوات لدى صاحب العمل",
  "Labour Law, article 109": "نظام العمل، المادة 109",
  "48 hours a week, 8 a day; 36 a week in Ramadan for Muslim workers":
    "48 ساعة أسبوعياً، و8 يومياً؛ و36 أسبوعياً في رمضان للعاملين المسلمين",
  "Labour Law, article 98": "نظام العمل، المادة 98",
  "Overtime: the hour's wage plus 50% of the hour's basic wage":
    "العمل الإضافي: أجر الساعة مضافاً إليه 50% من أجر الساعة الأساسي",
  "Labour Law, article 107": "نظام العمل، المادة 107",
  "Public holidays: Eid al-Fitr 4 days, Eid al-Adha 4 days, Founding Day, National Day":
    "العطل الرسمية: عيد الفطر 4 أيام، وعيد الأضحى 4 أيام، ويوم التأسيس، واليوم الوطني",
  "Implementing Regulations of the Labour Law": "اللائحة التنفيذية لنظام العمل",
  "Work-permit levy on each non-Saudi employee, monthly": "المقابل المالي على كل موظف غير سعودي، شهرياً",
  "Expat levy (al-muqabil al-mali), Council of Ministers decision":
    "المقابل المالي على العمالة الوافدة، بقرار مجلس الوزراء",
  "Iqama, work permit and exit/re-entry fees, yearly": "رسوم الإقامة ورخصة العمل وتأشيرة الخروج والعودة، سنوياً",
  "Jawazat and Ministry fee schedules": "جداول رسوم الجوازات والوزارة",
  "Medical cover for every employee (the premium is the policy's)": "تأمين طبي لكل موظف (القسط حسب الوثيقة)",
  "Cooperative Health Insurance Law (CHI)": "نظام الضمان الصحي التعاوني",
  "A Saudi counts in full at SAR 4,000 and half at SAR 3,000 (basic + housing registered with GOSI)":
    "يُحتسب السعودي كاملاً عند 4,000 ريال ونصفاً عند 3,000 ريال (الأساسي + السكن المسجلان في التأمينات)",
  "Nitaqat programme (HRSD / Qiwa); the band depends on the activity and size":
    "برنامج نطاقات (وزارة الموارد البشرية / قوى)؛ ويعتمد النطاق على النشاط والحجم",
  "An annual return ticket for non-Saudi staff": "تذكرة عودة سنوية للموظفين غير السعوديين",
  "Employment contract, not the law": "عقد العمل، لا النظام",
  "Five sick days a year allowed for in the hourly rate": "خمسة أيام مرضية سنوياً محسوبة في تكلفة الساعة",
  "A planning allowance (art. 117 sets sick pay, not an expected number)":
    "افتراض تخطيطي (المادة 117 تحدد أجر الإجازة المرضية، لا عدداً متوقعاً)",
  "By department": "حسب الإدارة",
  "month = gross pay + GOSI employer share on basic+housing (floored and capped) + end-of-service accrual (half a month's wage a year for five years, a month's after) + medical premium ÷ 12 + for non-Saudis the monthly levy and a twelfth of iqama, permit, exit/re-entry and ticket; an outsourced head is its contract charge. Hour = year ÷ (working days − leave − public holidays − sick allowance) × daily hours. Overtime = hourly wage + 50% of hourly basic (art. 107).":
    "الشهر = إجمالي الراتب + حصة صاحب العمل في التأمينات على الأساسي + السكن (بحد أدنى وأعلى) + مخصص نهاية الخدمة (أجر نصف شهر عن كل سنة للسنوات الخمس الأولى، وأجر شهر بعدها) + قسط التأمين الطبي ÷ 12 + لغير السعوديين المقابل المالي الشهري وجزء من اثني عشر من الإقامة ورخصة العمل وتأشيرة الخروج والعودة والتذكرة؛ وعامل المقاول تكلفته رسم عقده. الساعة = السنة ÷ (أيام العمل − الإجازة − العطل الرسمية − أيام المرض المحسوبة) × ساعات اليوم. العمل الإضافي = أجر الساعة + 50% من أجر الساعة الأساسي (المادة 107).",
  "Nitaqat share = Saudis counted ÷ (Saudis counted + non-Saudis), direct employees only. A Saudi counts 1 at or above the full-count wage (basic + housing, as registered with GOSI) and ½ at or above the half-count wage. Outsourced heads count for their contractor. Hires needed = full-count Saudis to add to reach the target with no one leaving.":
    "نسبة نطاقات = السعوديون المحتسبون ÷ (السعوديون المحتسبون + غير السعوديين)، للموظفين المباشرين فقط. يُحتسب السعودي 1 عند أجر الاحتساب الكامل أو فوقه (الأساسي + السكن كما هو مسجل في التأمينات) و½ عند أجر احتساب النصف أو فوقه. وعمالة المقاولين تُحتسب لمقاولهم. التوظيف المطلوب = عدد السعوديين المحتسبين كاملاً الواجب إضافتهم لبلوغ الهدف دون مغادرة أحد.",
  "cost = labour hours × the hourly cost of the person who did the work, when the work order names a platform user bound to an employee; otherwise × the mean hourly cost of the trade that works on the asset's category. Work with no hours, or no person and no asset trade, is counted, not costed. Plans: estimated hours × (365 ÷ interval days) × the trade's hourly cost.":
    "التكلفة = ساعات العمل × تكلفة ساعة الشخص الذي نفّذ العمل، حين يذكر أمر العمل مستخدماً على المنصة مرتبطاً بموظف؛ وإلا × متوسط تكلفة ساعة التخصص الذي يعمل على فئة الأصل. والعمل بلا ساعات، أو بلا شخص ولا تخصص أصل، يُعدّ دون أن يُسعَّر. الخطط: الساعات المقدّرة × (365 ÷ أيام الفاصل) × تكلفة ساعة التخصص.",
  "Personal details": "البيانات الشخصية",
  Male: "ذكر",
  Female: "أنثى",
  "e.g. Brother": "مثال: أخ",
  "Pay is not shown: it needs the pay permission. Everything else can be changed here.":
    "الراتب غير معروض: يتطلب صلاحية الرواتب. ويمكن تعديل كل ما عداه هنا.",
  "This person costs the airport {month} a month.": "يكلّف هذا الشخص المطار {month} في الشهر.",
  "That is {hour} for each hour worked.": "أي {hour} عن كل ساعة عمل.",
  "GOSI {pct}% ({regime}), end of service {eosb} a month; overtime is paid at {ot} an hour (art. 107).":
    "التأمينات {pct}% ({regime})، ونهاية الخدمة {eosb} شهرياً؛ ويُدفع العمل الإضافي بمعدل {ot} للساعة (المادة 107).",
  "You hold the {level} level.": "مستواك: {level}.",
  "Six levels, from the HR super admin with full access down to admin staff who never see pay.":
    "ستة مستويات، من المشرف العام للموارد البشرية بصلاحيات كاملة إلى الموظفين الإداريين الذين لا يرون الرواتب أبداً.",
  "Who can see salaries?": "من يستطيع رؤية الرواتب؟",
  "Your level": "مستواك",
  "What the platform gave you. The preview below only hides things; it never adds any.":
    "ما منحتك إياه المنصة. المعاينة أدناه تُخفي فقط ولا تضيف شيئاً.",
  Myself: "أنا",
  "Nobody holds this level yet.": "لا أحد يحمل هذا المستوى بعد.",
  "Give somebody an HR level": "امنح شخصاً مستوى في الموارد البشرية",
  "One level per person; choosing a new one replaces the old.":
    "مستوى واحد لكل شخص؛ واختيار مستوى جديد يحل محل القديم.",
  "Only the HR super admin gives levels.": "المشرف العام للموارد البشرية وحده يمنح المستويات.",
  "No HR access": "لا صلاحية في الموارد البشرية",
  "Give the level": "امنح المستوى",
  "Done. It takes effect at their next sign-in.": "تم. يسري عند تسجيل دخوله التالي.",
  "Who can do what": "من يستطيع فعل ماذا",
  Ability: "الصلاحية",
  "The platform administrator holds every HR key; the accountable manager and the project sponsor read the workforce and its cost.":
    "يملك مدير المنصة كل صلاحيات الموارد البشرية؛ ويطّلع المدير المسؤول وراعي المشروع على القوى العاملة وتكلفتها.",
  "{d}: {p} in, {l} late, {a} absent, {v} on leave or sick, {n} not recorded.":
    "{d}: {p} حاضرون، {l} متأخرون، {a} غائبون، {v} في إجازة أو مرض، {n} غير مسجلين.",
  "Who is absent today?": "من الغائب اليوم؟",
  "The day before": "اليوم السابق",
  "The day after": "اليوم التالي",
  "Mark the {n} not recorded as present": "سجّل الـ{n} غير المسجلين حاضرين",
  "Nobody here.": "لا أحد هنا.",
  "Tap a status to record it; it saves at once.": "اضغط على الحالة لتسجيلها؛ تُحفظ فوراً.",
  "Recording attendance needs the write permission.": "تسجيل الحضور يتطلب صلاحية التعديل.",
  In: "الدخول",
  "Minutes late": "دقائق التأخير",
  "End of service, vacation balance, sick-leave pay and the final settlement, by the Saudi labour rules in force.":
    "نهاية الخدمة ورصيد الإجازات وأجر الإجازة المرضية والتسوية النهائية، وفق أنظمة العمل السعودية السارية.",
  "How is end of service worked out?": "كيف تُحسب نهاية الخدمة؟",
  "Whose figures?": "أرقام من؟",
  "Choose a person to fill everything from their file, or leave it empty and type any figures.":
    "اختر شخصاً لتُملأ الأرقام من ملفه، أو اتركه فارغاً واكتب أي أرقام.",
  "Nobody — I will type the figures": "لا أحد — سأكتب الأرقام",
  "Pay is hidden from you, so type the monthly wage yourself.": "الراتب مخفي عنك، فاكتب الأجر الشهري بنفسك.",
  "Rates as of {d}, proposed until HR confirms them against GOSI, Qiwa and the Ministry. Everyone is paid monthly: a day is a month's wage over 30.":
    "المعدلات كما في {d}، مقترحة حتى تؤكدها الموارد البشرية مع التأمينات وقوى والوزارة. الجميع يتقاضون رواتب شهرية: أجر اليوم هو أجر الشهر ÷ 30.",
  "End-of-service award": "مكافأة نهاية الخدمة",
  "Labour Law art. 84, cut by art. 85 on resignation.": "المادة 84 من نظام العمل، مخفّضة بالمادة 85 عند الاستقالة.",
  "Vacation balance": "رصيد الإجازات",
  "Art. 109: {a} days a year, {b} after {y} years; art. 111: the balance is paid out on leaving.":
    "المادة 109: {a} يوماً في السنة، و{b} بعد {y} سنوات؛ المادة 111: يُصرف الرصيد عند ترك العمل.",
  "Taken days filled from the approved annual leave in the file.":
    "الأيام المأخوذة مملوءة من الإجازات السنوية المعتمدة في الملف.",
  "Earned since hiring": "المستحق منذ التعيين",
  Taken: "المأخوذ",
  "A day's wage (a month ÷ 30)": "أجر اليوم (الشهر ÷ 30)",
  "Worth if paid out": "قيمته إن صُرف",
  "Sick-leave pay": "أجر الإجازة المرضية",
  "Art. 117, in any twelve months: 30 days full pay, 60 at three quarters, 30 unpaid.":
    "المادة 117، خلال أي اثني عشر شهراً: 30 يوماً بأجر كامل، و60 بثلاثة أرباع الأجر، و30 دون أجر.",
  "Days at full pay": "أيام بأجر كامل",
  "Days at three quarters": "أيام بثلاثة أرباع الأجر",
  "Days unpaid": "أيام دون أجر",
  "Paid for this sick leave": "المدفوع عن هذه الإجازة المرضية",
  "Final settlement": "التسوية النهائية",
  "What is paid when somebody leaves: the end-of-service award, unused leave and the days of the last month not yet paid.":
    "ما يُدفع عند ترك الموظف العمل: مكافأة نهاية الخدمة، والإجازات غير المستخدمة، وأيام الشهر الأخير غير المدفوعة.",
  "Unused leave": "الإجازات غير المستخدمة",
  "Salary for the last days worked": "راتب الأيام الأخيرة المعمولة",
  "Loans, advances and deductions are not included; take them off the total. Settlement is due within a week of leaving, two weeks after a resignation (art. 88).":
    "القروض والسلف والخصومات غير مشمولة؛ اخصمها من الإجمالي. تستحق التسوية خلال أسبوع من ترك العمل، وخلال أسبوعين بعد الاستقالة (المادة 88).",
  "A person, on average, a month": "الشخص، في المتوسط، شهرياً",
  "salary and everything the airport pays on top": "الراتب وكل ما يدفعه المطار فوقه",
  "the month spread over the hours actually worked": "الشهر موزعاً على الساعات المعمولة فعلاً",
  "{n} people on the register; {p} in today, {a} absent, {l} on leave.":
    "{n} شخصاً في السجل؛ {p} حاضرون اليوم، و{a} غائبون، و{l} في إجازة.",
  "{n} requests are waiting for a decision.": "{n} طلبات بانتظار القرار.",
  "What is waiting for approval?": "ما الذي ينتظر الموافقة؟",
  "Find anyone, see who is in today, and deal with what is waiting — all from here.":
    "ابحث عن أي شخص، واعرف من حضر اليوم، وأنجز ما ينتظرك — كل ذلك من هنا.",
  "Search by name, employee number, job or ID…": "ابحث بالاسم أو رقم الموظف أو الوظيفة أو الهوية…",
  "Search for a person": "البحث عن شخص",
  "Nobody matches. Try part of the name.": "لا أحد يطابق. جرّب جزءاً من الاسم.",
  "Open the attendance sheet": "افتح كشف الحضور",
  "Waiting for a decision": "بانتظار القرار",
  "See all": "عرض الكل",
  "Nothing is waiting. 🎉": "لا شيء بانتظارك. 🎉",
  "Coming up in 30 days": "القادم خلال 30 يوماً",
  "Full list": "القائمة الكاملة",
  "Nothing in the next 30 days.": "لا شيء خلال الثلاثين يوماً القادمة.",
  "turns {n}": "يبلغ {n}",
  "Away today": "الغائبون اليوم",
  "Everybody recorded is in.": "كل المسجلين حاضرون.",
  "Everyone is paid a monthly salary. To price a job, each person's monthly cost is spread over the hours they actually work in a year; that hourly figure is used here and nowhere else unless you ask for it.":
    "الجميع يتقاضون رواتب شهرية. ولتسعير أي عمل، تُوزَّع التكلفة الشهرية لكل شخص على الساعات التي يعملها فعلاً في السنة؛ وتُستخدم تكلفة الساعة هذه هنا فقط إلا إذا طلبتها.",
  "Click anyone to open their staff file.": "انقر على أي شخص لفتح ملفه الوظيفي.",
  "Monthly salary": "الراتب الشهري",
  "{n} records in the staff files; {w} waiting for a decision.": "{n} سجلاً في الملفات الوظيفية؛ و{w} بانتظار القرار.",
  "Waiting for a decision ({n})": "بانتظار القرار ({n})",
  "Approve or reject here, or open the file first.": "وافق أو ارفض من هنا، أو افتح الملف أولاً.",
  "Deciding needs the approval permission.": "اتخاذ القرار يتطلب صلاحية الموافقة.",
  "Every record": "كل السجلات",
  "Click a row to open the person's file at that record.": "انقر على صف لفتح ملف الشخص عند ذلك السجل.",
  Any: "أي",
  "Name, number, title or reference": "الاسم أو الرقم أو العنوان أو المرجع",
  "No record matches.": "لا يوجد سجل مطابق.",
  "The first 500 are shown; narrow the filters to see the rest.": "تُعرض أول 500؛ ضيّق عوامل التصفية لرؤية الباقي.",
  "Reviews and disciplinary actions are not listed: they need the confidential permission.":
    "تقييمات الأداء والإجراءات التأديبية غير مدرجة: تتطلب الصلاحية السرية.",
  "{n} reports, shown as a table or chart, saved as CSV or printed.":
    "{n} تقارير، تُعرض جدولاً أو رسماً، وتُحفظ CSV أو تُطبع.",
  "Headcount by department": "عدد الموظفين حسب الإدارة",
  "Saved as a CSV file — it opens in Excel.": "حُفظ كملف CSV — يُفتح في إكسل.",
  "1. Choose a report": "1. اختر تقريراً",
  "2. Narrow it down": "2. ضيّق النطاق",
  "Direct and outsourced": "المباشرون وعمالة المقاولين",
  Everyone: "الجميع",
  Saudi: "سعودي",
  "Non-Saudi": "غير سعودي",
  "{n} rows": "{n} صفاً",
  "CSV for Excel": "CSV لإكسل",
  "Print or PDF": "طباعة أو PDF",
  "Nothing to report for these choices.": "لا شيء لهذه الاختيارات.",
  "The chart shows the first 16 rows.": "يعرض الرسم أول 16 صفاً.",
  "Only the HR super admin changes the rules.": "المشرف العام للموارد البشرية وحده يغيّر القواعد.",
  "The last day cannot be before the first.": "لا يمكن أن يسبق اليوم الأخير اليوم الأول.",
  "Say in a few words what this is.": "اذكر بكلمات قليلة ما هذا.",
  "This letter shows pay; it needs the pay permission.": "هذا الخطاب يُظهر الراتب؛ ويتطلب صلاحية الرواتب.",
  "The file is too large; 300 KB at most.": "الملف كبير جداً؛ 300 كيلوبايت كحد أقصى.",
  "{n} days.": "{n} يوماً.",
  "That is more than the {n} days the law gives.": "هذا أكثر من الـ{n} يوماً التي يمنحها النظام.",
  "e.g. Annual review 2026": "مثال: التقييم السنوي 2026",
  "e.g. Absent without notice": "مثال: غياب دون إشعار",
  "e.g. Work regulations, clause 12": "مثال: لائحة تنظيم العمل، البند 12",
  "Disciplinary actions are confidential: only the HR manager and the super admin can read them. The employee must be told in writing and heard first (Labour Law art. 71).":
    "الإجراءات التأديبية سرية: لا يطّلع عليها إلا مدير الموارد البشرية والمشرف العام. ويجب إبلاغ الموظف كتابةً وسماع أقواله أولاً (المادة 71 من نظام العمل).",
  "optional — To whom it may concern": "اختياري — إلى من يهمه الأمر",
  "e.g. traveling to Jordan from 1 to 14 November": "مثال: السفر إلى الأردن من 1 إلى 14 نوفمبر",
  "e.g. Iqama copy": "مثال: صورة الإقامة",
  "What to remember": "ما يجب تذكّره",
  "Approve it now (you hold the approval permission)": "اعتمدها الآن (لديك صلاحية الموافقة)",
  "Issue it now (you hold the approval permission)": "أصدره الآن (لديك صلاحية الموافقة)",
  "{name}, {title} in {dept}, {y} years' service.": "{name}، {title} في {dept}، خدمة {y} سنوات.",
  "What leave does this person have left?": "كم تبقى لهذا الشخص من إجازة؟",
  "Staff file": "الملف الوظيفي",
  "Human Resources": "الموارد البشرية",
  "Reviews and disciplinary actions are not shown: they need the confidential permission.":
    "تقييمات الأداء والإجراءات التأديبية غير معروضة: تتطلب الصلاحية السرية.",
  "Change the photo": "تغيير الصورة",
  "{y} years' service": "خدمة {y} سنوات",
  "Today: {s}": "اليوم: {s}",
  "Request leave": "طلب إجازة",
  Letter: "خطاب",
  Review: "تقييم",
  "days of annual leave left": "أيام متبقية من الإجازة السنوية",
  "attendance, last 30 days": "الحضور، آخر 30 يوماً",
  "sick days in 12 months": "أيام مرضية خلال 12 شهراً",
  "requests waiting": "طلبات منتظرة",
  "days to: {what}": "أيام حتى: {what}",
  "expires {d}": "تنتهي {d}",
  "Work and contract": "العمل والعقد",
  "ends {d}": "ينتهي {d}",
  "Pay and cost": "الراتب والتكلفة",
  "What this person is paid, and what they cost the airport.": "ما يتقاضاه هذا الشخص، وكم يكلّف المطار.",
  "Open the calculators": "افتح الحاسبات",
  "Pay is shown only to those with the pay permission.": "الراتب يُعرض فقط لمن لديه صلاحية الرواتب.",
  "Latest in the file": "أحدث ما في الملف",
  "Nothing recorded yet.": "لا شيء مسجل بعد.",
  "The last six weeks": "الأسابيع الستة الماضية",
  "Each square is a day; hover to see it.": "كل مربع يوم؛ مرّر المؤشر لرؤيته.",
  "{n} min late": "متأخر {n} دقيقة",
  "Day by day": "يوماً بيوم",
  "No attendance recorded yet.": "لا حضور مسجل بعد.",
  Out: "الخروج",
  "Art. 109: {a} days a year, {b} after {y} years.": "المادة 109: {a} يوماً في السنة، و{b} بعد {y} سنوات.",
  "An outsourced head's leave is the contractor's.": "إجازة عامل المقاول على المقاول.",
  "{n} days a year": "{n} يوماً في السنة",
  "Sick leave": "إجازة مرضية",
  "Leave history": "سجل الإجازات",
  "No leave recorded yet.": "لا إجازات مسجلة بعد.",
  Days: "الأيام",
  "Dates to remember": "تواريخ مهمة",
  "Birthdays, anniversaries and what expires, soonest first.": "أعياد الميلاد والذكريات وما ينتهي، الأقرب أولاً.",
  "Add the date of birth and ID expiry on Edit details to see them here.":
    "أضف تاريخ الميلاد وانتهاء الهوية من تعديل البيانات لتظهر هنا.",
  "Performance reviews": "تقييمات الأداء",
  "Confidential.": "سري.",
  "Add a review": "إضافة تقييم",
  "No review recorded yet.": "لا تقييم مسجل بعد.",
  Strengths: "نقاط القوة",
  Goals: "الأهداف",
  "Disciplinary actions": "الإجراءات التأديبية",
  "Record an action": "تسجيل إجراء",
  "A clean record: no disciplinary action.": "سجل نظيف: لا إجراء تأديبي.",
  "Letters & requests": "الخطابات والطلبات",
  "Click a letter to read, print or save it.": "انقر على خطاب لقراءته أو طباعته أو حفظه.",
  "New letter": "خطاب جديد",
  "No letter yet. Employment verification, salary certificates, NOCs and bank letters are one click away.":
    "لا خطابات بعد. خطابات التعريف وشهادات الراتب وعدم الممانعة وخطابات البنوك بنقرة واحدة.",
  "no reference yet": "لا مرجع بعد",
  "Documents & notes": "المستندات والملاحظات",
  "Add a document": "إضافة مستند",
  "No document yet.": "لا مستندات بعد.",
  "Click to open {file}": "انقر لفتح {file}",
  "kept on paper": "محفوظ ورقياً",
  "Draft — not issued yet": "مسودة — لم يصدر بعد",
  "Letters are written in English, as most banks and embassies ask; print them on the letterhead and sign.":
    "الخطابات مكتوبة بالإنجليزية كما تطلب معظم البنوك والسفارات؛ اطبعها على الورق الرسمي ووقّعها.",
  "Issue it": "أصدره",
  "You are seeing Human Resources as {level} would.": "أنت ترى الموارد البشرية كما يراها {level}.",
  "Back to my own view": "العودة إلى عرضي",
  "The photo could not be read.": "تعذّرت قراءة الصورة.",
  "That file is not a picture.": "هذا الملف ليس صورة.",
  "Show hourly rates too": "أظهر تكلفة الساعة أيضاً",
  "Date of birth": "تاريخ الميلاد",
  Gender: "الجنس",
  "Marital status": "الحالة الاجتماعية",
  "ID / iqama expires": "انتهاء الهوية / الإقامة",
  "Passport number": "رقم الجواز",
  "Passport expires": "انتهاء الجواز",
  Mobile: "الجوال",
  Email: "البريد الإلكتروني",
  Address: "العنوان",
  "Emergency contact": "جهة اتصال للطوارئ",
  "Their mobile": "جواله",
  Calculators: "الحاسبات",
  Calculator: "الحاسبة",
  "Balance on": "الرصيد في",
  "Days of annual leave already taken": "أيام الإجازة السنوية المأخوذة",
  "Monthly salary (SAR)": "الراتب الشهري (ريال)",
  "Sick days already used this year": "الأيام المرضية المستخدمة هذا العام",
  "Days of this sick leave": "أيام هذه الإجازة المرضية",
  "Monthly wage for end of service (SAR)": "الأجر الشهري لنهاية الخدمة (ريال)",
  "Unused annual leave (days)": "الإجازة السنوية غير المستخدمة (أيام)",
  "Days of the last month not yet paid": "أيام الشهر الأخير غير المدفوعة",
  "Records registry": "سجل الملفات",
  "Kind of record": "نوع السجل",
  Leave: "الإجازات",
  Letters: "الخطابات",
  Reviews: "التقييمات",
  Attendance: "الحضور",
  Absent: "غائب",
  "On leave or sick": "في إجازة أو مرض",
  "Not recorded yet": "غير مسجل بعد",
  "Type of leave": "نوع الإجازة",
  "First day": "اليوم الأول",
  "Last day": "اليوم الأخير",
  Rating: "التقدير",
  "Goals for next year": "أهداف العام القادم",
  "Rule or article": "القاعدة أو المادة",
  "Addressed to": "موجّه إلى",
  Purpose: "الغرض",
  "File (PDF or picture, up to 300 KB)": "الملف (PDF أو صورة، حتى 300 كيلوبايت)",
  "Show as": "اعرض كـ",
  Table: "جدول",
  Chart: "رسم",
  Cards: "بطاقات",
  Passport: "جواز السفر",
  "Hours a week": "ساعات الأسبوع",
  "Contract charge": "رسم العقد",
  "Other allowances": "بدلات أخرى",
  "Gross a month": "الإجمالي الشهري",
  "Cost to the airport, a month": "التكلفة على المطار، شهرياً",
  "An hour of work": "ساعة العمل",
  Present: "حاضر",
  Sick: "مريض",
  "Attendance rate": "نسبة الحضور",
  "Asked for, not yet decided": "مطلوبة ولم يُبت فيها",
  "Earning now": "الاستحقاق الحالي",
  "Worth if paid out (art. 111)": "قيمتها إن صُرفت (المادة 111)",
  "Used in 12 months": "المستخدم خلال 12 شهراً",
  "Left at full pay": "المتبقي بأجر كامل",
  "Left at three quarters": "المتبقي بثلاثة أرباع الأجر",
  "Left unpaid": "المتبقي دون أجر",
  "The next sick day is paid": "يُدفع اليوم المرضي التالي",
  Dates: "التواريخ",
  Performance: "الأداء",
  "Access levels": "مستويات الصلاحية",
  "See the suite as": "اعرض المجموعة كـ",
  "Person (their platform sign-in)": "الشخص (حسابه على المنصة)",
  "Add a person": "إضافة شخص",
  "New joiner": "موظف جديد",
  "Take attendance": "تسجيل الحضور",
  "Approve requests": "اعتماد الطلبات",
  "Leave and letters": "الإجازات والخطابات",
  "All staff": "جميع الموظفين",
  "The workforce register": "سجل القوى العاملة",
  "End of service, vacation, final pay": "نهاية الخدمة، الإجازات، المستحقات النهائية",
  "Tables, charts, CSV, print": "جداول، رسوم، CSV، طباعة",
  "Every file entry": "كل قيود الملفات",
  "Who can see what": "من يرى ماذا",
  Remote: "عن بُعد",
  "Day off": "يوم راحة",
  Holiday: "عطلة",
  "art. 109: 21 days a year, 30 after five years": "المادة 109: 21 يوماً في السنة، و30 بعد خمس سنوات",
  "art. 117: 30 days full pay, 60 at three quarters, 30 unpaid, in a year":
    "المادة 117: 30 يوماً بأجر كامل، و60 بثلاثة أرباعه، و30 دون أجر، خلال السنة",
  "Hajj leave": "إجازة الحج",
  "art. 114: 10 to 15 days with pay, once, after two years' service":
    "المادة 114: من 10 إلى 15 يوماً بأجر، مرة واحدة، بعد سنتين من الخدمة",
  "Marriage leave": "إجازة الزواج",
  "art. 113: 5 days with pay": "المادة 113: 5 أيام بأجر",
  "Birth of a child": "ولادة مولود",
  "art. 113: 3 days with pay": "المادة 113: 3 أيام بأجر",
  Bereavement: "إجازة الوفاة",
  "art. 113: 5 days with pay on the death of a spouse, parent or child":
    "المادة 113: 5 أيام بأجر عند وفاة الزوج أو أحد الوالدين أو الأبناء",
  "Maternity leave": "إجازة الوضع",
  "art. 151: 12 weeks with full pay": "المادة 151: 12 أسبوعاً بأجر كامل",
  "Iddah (widowhood)": "إجازة العدة",
  "art. 160: 4 months and 10 days with pay": "المادة 160: أربعة أشهر وعشرة أيام بأجر",
  "Exam leave": "إجازة الامتحانات",
  "art. 115: the exam days, with pay where the study is approved":
    "المادة 115: أيام الامتحان، بأجر إن كانت الدراسة معتمدة",
  "Unpaid leave": "إجازة دون أجر",
  "art. 116: by agreement": "المادة 116: بالاتفاق",
  "Employment verification letter": "خطاب تعريف بالعمل",
  "Salary certificate": "شهادة راتب",
  "Experience certificate": "شهادة خبرة",
  "No-objection letter (NOC)": "خطاب عدم ممانعة",
  "Salary transfer letter to a bank": "خطاب تحويل راتب إلى بنك",
  "Letter to an embassy (visa)": "خطاب إلى سفارة (تأشيرة)",
  Birthday: "عيد الميلاد",
  "Work anniversary": "ذكرى التعيين",
  "Probation ends": "انتهاء فترة التجربة",
  "Reaches retirement age (60)": "بلوغ سن التقاعد (60)",
  "HR Super Admin": "المشرف العام للموارد البشرية",
  "Full access: every file, pay, reviews and discipline, approvals, the labour rules, and who gets which HR level.":
    "صلاحية كاملة: كل الملفات والرواتب والتقييمات والتأديب والموافقات وأنظمة العمل ومن يحصل على أي مستوى.",
  "HR Manager": "مدير الموارد البشرية",
  "Every file, pay, reviews and discipline; approves leave and letters. Cannot change the rules or the levels.":
    "كل الملفات والرواتب والتقييمات والتأديب؛ ويعتمد الإجازات والخطابات. ولا يغيّر القواعد أو المستويات.",
  "Payroll Officer": "مسؤول الرواتب",
  "Pay, overtime, manpower cost and end of service. Sees no reviews or discipline and approves nothing.":
    "الرواتب والعمل الإضافي وتكلفة القوى العاملة ونهاية الخدمة. لا يرى التقييمات ولا التأديب ولا يعتمد شيئاً.",
  "HR Officer": "أخصائي الموارد البشرية",
  "Keeps the staff files, attendance and leave, issues letters and approves requests. Does not see pay.":
    "يحفظ الملفات الوظيفية والحضور والإجازات، ويصدر الخطابات ويعتمد الطلبات. ولا يرى الرواتب.",
  "HR Assistant": "مساعد الموارد البشرية",
  "Admin staff: personal details, photos, attendance, and leave and letter requests for others to approve. No pay.":
    "الموظفون الإداريون: البيانات الشخصية والصور والحضور، وطلبات الإجازات والخطابات ليعتمدها غيرهم. دون رواتب.",
  "Executive (cost oversight)": "تنفيذي (متابعة التكلفة)",
  "Reads the workforce and its cost. Changes nothing.": "يطّلع على القوى العاملة وتكلفتها. ولا يغيّر شيئاً.",
  "Sees no one's file or pay.": "لا يرى ملف أحد ولا راتبه.",
  "See the register and each staff file": "رؤية السجل وكل ملف وظيفي",
  "Add people, edit details and photos, record attendance, file requests":
    "إضافة الأشخاص وتعديل البيانات والصور وتسجيل الحضور وتقديم الطلبات",
  "See and change pay; manpower cost, labour cost, end of service":
    "رؤية الرواتب وتعديلها؛ تكلفة القوى العاملة والعمالة ونهاية الخدمة",
  "Read and write performance reviews and disciplinary actions": "قراءة وكتابة تقييمات الأداء والإجراءات التأديبية",
  "Approve or reject leave and issue letters": "اعتماد الإجازات أو رفضها وإصدار الخطابات",
  "Change the labour rules and give people HR levels": "تغيير أنظمة العمل ومنح مستويات الموارد البشرية",
  Headcount: "عدد الموظفين",
  "How many people, grouped as you choose, with the Saudi share.": "عدد الأشخاص مجمّعين كما تختار، مع نسبة السعوديين.",
  "Staff directory": "دليل الموظفين",
  "Everyone with their department, title, phone and email.": "الجميع مع الإدارة والمسمى والهاتف والبريد.",
  "Attendance by person": "الحضور لكل شخص",
  "Days present, late, absent, on leave and sick in the period, and the attendance rate.":
    "أيام الحضور والتأخر والغياب والإجازة والمرض خلال الفترة، ونسبة الحضور.",
  "Leave taken": "الإجازات المأخوذة",
  "Every approved leave in the period, by type.": "كل إجازة معتمدة خلال الفترة، حسب النوع.",
  "Sick leave and pay tiers": "الإجازات المرضية وشرائح الأجر",
  "Sick days used in the last year and what is left at full, three-quarter and no pay (art. 117).":
    "الأيام المرضية المستخدمة في السنة الماضية والمتبقي بأجر كامل وثلاثة أرباع ودون أجر (المادة 117).",
  "Leave balances": "أرصدة الإجازات",
  "Annual leave earned, taken and left for each person, and what the balance is worth.":
    "الإجازة السنوية المستحقة والمأخوذة والمتبقية لكل شخص، وقيمة الرصيد.",
  "Birthdays, anniversaries and expiries": "أعياد الميلاد والذكريات وانتهاء الوثائق",
  "What falls due in the next 90 days: birthdays, work anniversaries, ID, passport and contract ends.":
    "ما يحل خلال 90 يوماً: أعياد الميلاد وذكريات التعيين وانتهاء الهوية والجواز والعقد.",
  "Saudization by department": "السعودة حسب الإدارة",
  "The Nitaqat share of each department.": "نسبة نطاقات لكل إدارة.",
  "Letters and requests": "الخطابات والطلبات",
  "Every letter issued or requested in the period, with its reference.": "كل خطاب صادر أو مطلوب خلال الفترة، مع مرجعه.",
  "Monthly and yearly cost, grouped as you choose.": "التكلفة الشهرية والسنوية مجمّعة كما تختار.",
  "End-of-service liability": "التزام نهاية الخدمة",
  "What each person would be owed on leaving today (art. 84).": "ما يستحقه كل شخص لو ترك العمل اليوم (المادة 84).",
  "Each review with its rating and reviewer.": "كل تقييم مع تقديره والمقيّم.",
  "Each action, its type and whether it is closed.": "كل إجراء ونوعه وهل أُغلق.",
  "Saudi %": "نسبة السعوديين %",
  "Attendance %": "نسبة الحضور %",
  "Sick days, 12 months": "أيام مرضية، 12 شهراً",
  "Full pay left": "المتبقي بأجر كامل",
  "¾ pay left": "المتبقي بـ¾ الأجر",
  "Unpaid left": "المتبقي دون أجر",
  "Next sick day is paid": "اليوم المرضي التالي يُدفع",
  Earned: "المستحق",
  "Balance (days)": "الرصيد (أيام)",
  "Worth (SAR)": "القيمة (ريال)",
  "In days": "بعد أيام",
  Years: "السنوات",
  "Direct people": "الموظفون المباشرون",
  "Saudization %": "السعودة %",
  "A month (SAR)": "شهرياً (ريال)",
  "A year (SAR)": "سنوياً (ريال)",
  "Wage (SAR)": "الأجر (ريال)",
  "If ended by employer (SAR)": "إن أنهاها صاحب العمل (ريال)",
  "If they resign (SAR)": "إن استقال (ريال)",
  "Recorded by": "سجّله",
  "HR home": "الرئيسية للموارد البشرية",
  "HR reports": "تقارير الموارد البشرية",
  "Good morning": "صباح الخير",
  "Good afternoon": "طاب يومك",
  "Good evening": "مساء الخير",
  Sun: "أحد",
  Mon: "اثنين",
  Tue: "ثلاثاء",
  Wed: "أربعاء",
  Thu: "خميس",
  Fri: "جمعة",
  Sat: "سبت",
  full: "كامل",
  "three quarters": "ثلاثة أرباع",
  unpaid: "دون أجر",
  exhausted: "مستنفد",
  Single: "أعزب",
  Married: "متزوج",
  Divorced: "مطلق",
  Widowed: "أرمل",
  "Exceeds expectations": "يفوق التوقعات",
  "Meets expectations": "يلبي التوقعات",
  "Needs improvement": "يحتاج إلى تحسين",
  Unsatisfactory: "غير مرضٍ",
  "Verbal warning": "إنذار شفهي",
  "Written warning": "إنذار كتابي",
  "Final written warning": "إنذار كتابي نهائي",
  "Salary deduction": "حسم من الأجر",
  "Suspension without pay": "إيقاف عن العمل دون أجر",
  "Dismissal (art. 80)": "الفصل (المادة 80)",
  "Request or issue a letter": "طلب خطاب أو إصداره",
  "Add a performance review": "إضافة تقييم أداء",
  "Record a disciplinary action": "تسجيل إجراء تأديبي",
  "Performance review": "تقييم أداء",
  "Disciplinary action": "إجراء تأديبي",
  "The people and everything HR keeps about them: a file for each person, attendance, leave, letters, reports, and what they cost under Saudi law.":
    "الموظفون وكل ما تحفظه الموارد البشرية عنهم: ملف لكل شخص، والحضور، والإجازات، والخطابات، والتقارير، وتكلفتهم وفق النظام السعودي.",
  "Start at HR home: find anyone, see who is in today and what is waiting for a decision. Each person has a staff file with their photo and personal details, daily attendance, annual and sick leave with what is left, birthdays, anniversaries and expiries, performance reviews and discipline (confidential), letters such as employment verification and salary certificates, and documents. Calculators work out end of service, the vacation balance, sick-leave pay and the final settlement; reports come as tables, charts, CSV or print.":
    "ابدأ من الرئيسية: ابحث عن أي شخص، واعرف من حضر اليوم وما ينتظر القرار. لكل شخص ملف وظيفي بصورته وبياناته الشخصية، وحضوره اليومي، وإجازاته السنوية والمرضية مع المتبقي، وأعياد الميلاد والذكريات وانتهاء الوثائق، وتقييمات الأداء والتأديب (سرية)، والخطابات مثل التعريف بالعمل وشهادات الراتب، والمستندات. وتحسب الحاسبات نهاية الخدمة ورصيد الإجازات وأجر الإجازة المرضية والتسوية النهائية؛ وتأتي التقارير جداول ورسوماً وCSV وطباعة.",
  "Everyone is paid a monthly salary, and the cost screens lead with the month: pay plus GOSI, the end-of-service accrual, medical cover and, for non-Saudis, the levy and fees. The hourly figure is kept as an option and prices work orders and maintenance plans. Access comes in six levels, from the HR super admin down to admin staff who never see pay.":
    "الجميع يتقاضون رواتب شهرية، وشاشات التكلفة تبدأ بالشهر: الراتب مع التأمينات ومخصص نهاية الخدمة والتأمين الطبي، ولغير السعوديين المقابل المالي والرسوم. وتبقى تكلفة الساعة خياراً تُسعَّر به أوامر العمل وخطط الصيانة. والصلاحيات ستة مستويات، من المشرف العام إلى الموظفين الإداريين الذين لا يرون الرواتب.",
  "Search for anyone, the everyday jobs as big buttons, who is in, late, absent or away today, the requests waiting for a decision, and the birthdays, anniversaries and expiries coming up.":
    "ابحث عن أي شخص، والمهام اليومية أزراراً كبيرة، ومن حضر أو تأخر أو غاب اليوم، والطلبات المنتظرة، وأعياد الميلاد والذكريات وانتهاء الوثائق القادمة.",
  "One day, everybody: tap present, late, absent, on leave, sick or remote for each person, mark everyone not yet recorded as present in one go, and open anyone's file.":
    "يوم واحد والجميع: اضغط حاضر أو متأخر أو غائب أو إجازة أو مريض أو عن بُعد لكل شخص، وسجّل كل غير المسجلين حاضرين دفعة واحدة، وافتح ملف أي شخص.",
  "Every entry in every staff file — leave, letters, reviews, discipline, documents and notes — filtered by kind, status, department or name, with requests to approve on top; a row opens the file.":
    "كل قيد في كل ملف وظيفي — الإجازات والخطابات والتقييمات والتأديب والمستندات والملاحظات — مصفّاة حسب النوع والحالة والإدارة والاسم، والطلبات المنتظرة في الأعلى؛ والصف يفتح الملف.",
  "End of service (arts. 84 and 85), the vacation balance and what it is worth, sick-leave pay by art. 117's tiers, and the final settlement, filled from a person's file or typed.":
    "نهاية الخدمة (المادتان 84 و85)، ورصيد الإجازات وقيمته، وأجر الإجازة المرضية حسب شرائح المادة 117، والتسوية النهائية، من ملف الشخص أو بالإدخال.",
  "Thirteen reports — headcount, directory, attendance, leave, sick leave, balances, dates, Saudization, letters, cost, end of service, reviews, discipline — filtered and grouped, as a table or chart, saved as CSV or printed.":
    "ثلاثة عشر تقريراً — العدد والدليل والحضور والإجازات والمرضية والأرصدة والتواريخ والسعودة والخطابات والتكلفة ونهاية الخدمة والتقييمات والتأديب — مصفّاة ومجمّعة، جدولاً أو رسماً، تُحفظ CSV أو تُطبع.",
  "The six HR levels from super admin to admin staff, what each can do and who holds it; the super admin gives levels here, and anyone can preview the suite as a lower level sees it.":
    "مستويات الموارد البشرية الستة من المشرف العام إلى الموظفين الإداريين، وما يستطيعه كل منها ومن يحمله؛ يمنح المشرف العام المستويات هنا، ويستطيع أي أحد معاينة المجموعة كما يراها مستوى أدنى.",
  "{n} not recorded yet": "{n} غير مسجلين بعد",
  "Everyone is recorded": "الجميع مسجلون",
  "Check-ins and outs": "الحضور والانصراف",
  "Newest first. Phone check-ins are only accepted inside a designated location; readers send their own feed.":
    "الأحدث أولاً. يُقبل الحضور بالجوال داخل موقع محدد فقط؛ وترسل الأجهزة بياناتها بنفسها.",
  "No check-in recorded for this day.": "لا حضور مسجل لهذا اليوم.",
  "In or out": "دخول أو خروج",
  Distance: "المسافة",
  "Open the spot on a map": "افتح الموقع على الخريطة",
  "{m} m": "{m} م",
  "Record by hand": "تسجيل يدوي",
  "A forgotten phone or a broken reader: HR records it and says why. It is marked as recorded by HR.":
    "جوال منسي أو جهاز معطّل: تسجّله الموارد البشرية وتذكر السبب، ويُوسم بأنه مسجّل من الموارد البشرية.",
  "e.g. Phone battery died; seen at the gate by the supervisor": "مثال: نفدت بطارية الجوال؛ رآه المشرف عند البوابة",
  "The location could not be read here; type the coordinates instead.":
    "تعذّرت قراءة الموقع هنا؛ اكتب الإحداثيات بدلاً من ذلك.",
  "Where people may check in by phone": "أماكن تسجيل الحضور بالجوال",
  "A phone check-in is accepted only inside one of these circles, and only at those HR allowed for the person.":
    "يُقبل الحضور بالجوال داخل إحدى هذه الدوائر فقط، وفي ما سمحت به الموارد البشرية للشخص.",
  "No location yet. Add the first one below — nobody can check in by phone until there is one.":
    "لا مواقع بعد. أضف أولها أدناه — لا يمكن لأحد تسجيل الحضور بالجوال حتى يوجد موقع.",
  "Center": "المركز",
  Radius: "نصف القطر",
  "Shift starts": "بداية الوردية",
  "Grace (min)": "السماح (دقيقة)",
  Off: "متوقف",
  On: "يعمل",
  "Add a location": "إضافة موقع",
  "Stand at the place and press the button, or type its coordinates.": "قف في المكان واضغط الزر، أو اكتب إحداثياته.",
  "e.g. Fire station": "مثال: محطة الإطفاء",
  "Use where I am now": "استخدم موقعي الحالي",
  "Add the location": "أضف الموقع",
  "Only the HR super admin adds or changes locations.": "المشرف العام للموارد البشرية وحده يضيف المواقع أو يغيّرها.",
  "Face and fingerprint readers": "أجهزة الوجه والبصمة",
  "The readers identify the person themselves and send their feed to the platform.":
    "تتعرّف الأجهزة على الشخص بنفسها وترسل بياناتها إلى المنصة.",
  "Enroll each person on the reader with their employee number": "سجّل كل شخص في الجهاز برقمه الوظيفي",
  "The face or fingerprint stays on the reader system; the platform receives only who, when and which reader.":
    "تبقى صورة الوجه أو البصمة في نظام الجهاز؛ وتتلقى المنصة فقط من ومتى وأي جهاز.",
  "Give the reader system an integration key": "امنح نظام الأجهزة مفتاح ربط",
  "Administration issues it; it can post check-ins and nothing else in Human Resources.":
    "تصدره الإدارة؛ ولا يستطيع إلا إرسال سجلات الحضور في الموارد البشرية.",
  "Point its feed at the platform": "وجّه بياناته إلى المنصة",
  "One event or a batch; a repeated event is counted once, an unknown employee number is reported without losing the rest.":
    "حدث واحد أو دفعة؛ ويُحتسب الحدث المكرر مرة واحدة، ويُبلَّغ عن الرقم الوظيفي غير المعروف دون فقدان الباقي.",
  "A reader event for somebody HR has not set to use that kind of reader is refused, like a phone check-in. Each reader brand needs a small adapter from its own export or push format to this one.":
    "يُرفض حدث الجهاز لشخص لم تحدده الموارد البشرية لذلك النوع من الأجهزة، كما يُرفض الحضور بالجوال. ويحتاج كل نوع من الأجهزة محوّلاً صغيراً من صيغته إلى هذه الصيغة.",
  "How they check in and out": "طريقة تسجيل حضوره وانصرافه",
  "HR's decision, by where they work, their job and access to restricted areas. Anything else is refused.":
    "قرار الموارد البشرية، حسب مكان العمل والوظيفة والدخول إلى المناطق المقيّدة. وكل ما عداه يُرفض.",
  "Not decided yet: until HR chooses, readers are accepted and the phone is not.":
    "لم يُحدَّد بعد: حتى تختار الموارد البشرية، تُقبل الأجهزة ولا يُقبل الجوال.",
  "By phone at: {places}": "بالجوال في: {places}",
  "By phone at any designated location": "بالجوال في أي موقع محدد",
  "Set on {d}": "حُدّد في {d}",
  "Where they may check in by phone": "أين يُسمح له بتسجيل الحضور بالجوال",
  "Any designated location": "أي موقع محدد",
  "Choose a common reason…": "اختر سبباً شائعاً…",
  "With nothing ticked, readers are accepted and the phone is not.":
    "دون اختيار أي شيء، تُقبل الأجهزة ولا يُقبل الجوال.",
  "The person is told by SMS and email that how they check in has changed.":
    "يُبلَّغ الشخص برسالة نصية وبريد بأن طريقة تسجيل حضوره تغيّرت.",
  "You checked in at {t} today.": "سجّلت حضورك اليوم الساعة {t}.",
  "You have not checked in today.": "لم تسجّل حضورك اليوم.",
  "How much leave do I have?": "كم لدي من الإجازة؟",
  "This browser cannot tell where the phone is.": "لا يستطيع هذا المتصفح تحديد موقع الجوال.",
  "Location is switched off for this app. Allow location in the phone's settings and try again.":
    "الموقع مغلق لهذا التطبيق. فعّل الموقع من إعدادات الجوال وحاول مجدداً.",
  "The phone could not find where it is. Step outside or near a window and try again.":
    "تعذّر تحديد موقع الجوال. اخرج أو اقترب من نافذة وحاول مجدداً.",
  "Hello, {name}": "أهلاً، {name}",
  "Checked in today at {t}{late}.": "سجّلت حضورك اليوم الساعة {t}{late}.",
  "Checked out at {t}.": "سجّلت انصرافك الساعة {t}.",
  "Check in at the {what}.": "سجّل حضورك عبر {what}.",
  "HR has not yet set how you check in; use a face or fingerprint reader for now.":
    "لم تحدّد الموارد البشرية طريقة تسجيل حضورك بعد؛ استخدم جهاز الوجه أو البصمة حالياً.",
  "Finding where you are…": "جارٍ تحديد موقعك…",
  "Find me again": "حدّد موقعي مجدداً",
  "Find where I am": "حدّد موقعي",
  "Pretend I am at work (demonstration)": "افترض أنني في العمل (عرض توضيحي)",
  "You are at {place} ({d} m from its center).": "أنت في {place} (على بعد {d} م من مركزه).",
  "accurate to {m} m": "بدقة {m} م",
  "Check in": "تسجيل الحضور",
  "Start of the day": "بداية اليوم",
  "Check out": "تسجيل الانصراف",
  "End of the day": "نهاية اليوم",
  "Recorded at {place}, {t}.": "سُجّل في {place}، {t}.",
  "Nothing yet today.": "لا شيء اليوم بعد.",
  "Checked in": "حضر",
  "Checked out": "انصرف",
  "Where you may check in": "أين يمكنك تسجيل الحضور",
  "My requests": "طلباتي",
  "Every answer is also sent to you by SMS and email.": "يُرسل إليك كل رد أيضاً برسالة نصية وبريد.",
  "You have not asked HR for anything yet.": "لم تطلب شيئاً من الموارد البشرية بعد.",
  "asked {d}": "طُلب في {d}",
  "Ask HR": "اطلب من الموارد البشرية",
  "Leave, a letter, or a change — HR decides and you are told.":
    "إجازة أو خطاب أو تغيير — تقرر الموارد البشرية ويصلك الرد.",
  "HR has no mobile number or email for you, so answers will not reach you by SMS or email. Ask HR to add them.":
    "لا تملك الموارد البشرية رقم جوالك ولا بريدك، فلن تصلك الردود برسالة أو بريد. اطلب منها إضافتهما.",
  "HR has no mobile number for you; answers will come by email only.":
    "لا تملك الموارد البشرية رقم جوالك؛ ستصلك الردود بالبريد فقط.",
  "HR has no email for you; answers will come by SMS only.":
    "لا تملك الموارد البشرية بريدك؛ ستصلك الردود برسالة نصية فقط.",
  "Sent to HR. You will get an SMS and an email when it is decided.":
    "أُرسل إلى الموارد البشرية. ستصلك رسالة نصية وبريد عند البت فيه.",
  "Send to HR": "أرسل إلى الموارد البشرية",
  "Requests go to HR for a decision.": "تذهب الطلبات إلى الموارد البشرية للبت فيها.",
  "{n} messages: {s} sent, {w} not sent.": "{n} رسالة: {s} أُرسلت، و{w} لم تُرسل.",
  "Why were messages not sent?": "لماذا لم تُرسل الرسائل؟",
  "Send what is waiting": "أرسل المنتظر",
  "Every request, and every answer, approval or change to one, is sent to the person by SMS and email to the number and address on their file — Arabic first, then English. A confidential record is never described in a message.":
    "كل طلب، وكل رد أو موافقة أو تغيير عليه، يُرسل إلى الشخص برسالة نصية وبريد إلى الرقم والعنوان في ملفه — بالعربية أولاً ثم الإنجليزية. ولا يُوصف أي سجل سري في رسالة.",
  Sending: "الإرسال",
  "Sent {a}; not sent {b} (no provider); failed {c}.": "أُرسل {a}؛ لم يُرسل {b} (لا مزوّد)؛ فشل {c}.",
  "The outbox": "صندوق الصادر",
  "Click a message to read it.": "انقر على رسالة لقراءتها.",
  "SMS and email": "الرسائل النصية والبريد",
  Ready: "جاهز",
  "Not set up": "غير مُعد",
  "SMS through {p}, sender {s}": "رسائل نصية عبر {p}، باسم المرسل {s}",
  "SMS needs a Saudi SMS provider account and a sender name registered with the Communications, Space and Technology Commission.":
    "تحتاج الرسائل النصية حساباً لدى مزوّد رسائل سعودي واسم مرسل مسجلاً لدى هيئة الاتصالات والفضاء والتقنية.",
  "Email from {f}": "البريد من {f}",
  "Email needs the skylogics.ai Microsoft 365 mailbox connected (or an SMTP server).":
    "يحتاج البريد ربط صندوق skylogics.ai على مايكروسوفت 365 (أو خادم SMTP).",
  "No message yet.": "لا رسائل بعد.",
  "no contact on file": "لا وسيلة اتصال في الملف",
  "Send again": "أعد الإرسال",
  "e.g. Move to the night shift": "مثال: الانتقال إلى الوردية الليلية",
  "The person is told by SMS and email that the request was received, and again when it is decided.":
    "يُبلَّغ الشخص برسالة نصية وبريد باستلام الطلب، ومرة أخرى عند البت فيه.",
  "Check-ins today": "الحضور اليوم",
  "No check-in today yet.": "لا حضور اليوم بعد.",
  "Messages sent to this person": "الرسائل المرسلة إلى هذا الشخص",
  "Every request, answer and change goes by SMS and email to the contacts on file.":
    "كل طلب ورد وتغيير يُرسل برسالة نصية وبريد إلى وسائل الاتصال في الملف.",
  Latitude: "خط العرض",
  Longitude: "خط الطول",
  "Radius (m)": "نصف القطر (م)",
  "Why (the reason on the file)": "السبب (المدوّن في الملف)",
  "Or in your own words": "أو بكلماتك",
  Messages: "الرسائل",
  Channel: "القناة",
  "My check-in": "حضوري",
  "What do you need?": "ماذا تحتاج؟",
  "In a few words": "باختصار",
  "Details (optional)": "تفاصيل (اختياري)",
  "Attendance views": "عروض الحضور",
  "Attendance sheet": "كشف الحضور",
  "Check-ins": "سجلات الحضور",
  Locations: "المواقع",
  "Face & fingerprint readers": "أجهزة الوجه والبصمة",
  "What is asked for": "المطلوب",
  Requests: "الطلبات",
  "Phone, by location": "الجوال، حسب الموقع",
  "Phone, location and face or fingerprint": "الجوال، بالموقع والوجه أو البصمة",
  "Phone face check": "التحقق بالوجه على الجوال",
  "Phone fingerprint": "البصمة على الجوال",
  "Face recognition reader": "جهاز التعرف على الوجه",
  "Fingerprint reader": "جهاز البصمة",
  "Recorded by HR": "سجّلته الموارد البشرية",
  "Restricted and airside areas, where the person must be proven at the gate.":
    "المناطق المقيّدة والجانب الجوي، حيث يجب إثبات هوية الشخص عند البوابة.",
  "Buildings with a reader at the entrance: terminal, offices, plant rooms.":
    "المباني التي عند مدخلها جهاز: الصالة والمكاتب وغرف المعدات.",
  "Field staff who start at different places, or where there is no reader.":
    "الموظفون الميدانيون الذين يبدؤون من أماكن مختلفة، أو حيث لا يوجد جهاز.",
  "Waiting to send": "بانتظار الإرسال",
  Sent: "أُرسل",
  "No number or email on file": "لا رقم ولا بريد في الملف",
  "Not sent — no provider set up": "لم يُرسل — لا مزوّد مُعد",
  "A letter (employment, salary, NOC…)": "خطاب (تعريف، راتب، عدم ممانعة…)",
  "A change to my status or shift": "تغيير في حالتي أو ورديتي",
  "A change to my personal details": "تغيير في بياناتي الشخصية",
  "A salary advance": "سلفة على الراتب",
  "A loan": "قرض",
  "A transfer": "نقل",
  Training: "تدريب",
  "Something else": "شيء آخر",
  "Works airside; restricted area — fingerprint reader only": "يعمل في الجانب الجوي؛ منطقة مقيّدة — جهاز البصمة فقط",
  "Office-based; the building has a face reader": "عمل مكتبي؛ في المبنى جهاز للتعرف على الوجه",
  "Field staff across the airfield; checks in by phone at the location":
    "موظف ميداني في أرجاء المطار؛ يسجّل حضوره بالجوال في الموقع",
  "Shift work in the terminal; face reader at the staff entrance":
    "عمل بنظام الورديات في الصالة؛ جهاز الوجه عند مدخل الموظفين",
  "Contractor staff; fingerprint reader at the contractor gate": "عمالة مقاول؛ جهاز البصمة عند بوابة المقاولين",
  "Request received": "استُلم الطلب",
  "Not approved": "لم يُعتمد",
  "Letter issued": "صدر الخطاب",
  "Employment status changed": "تغيّرت الحالة الوظيفية",
  "Confidential record added": "أُضيف سجل سري",
  "Check-in method changed": "تغيّرت طريقة تسجيل الحضور",
  "the demonstration sends nothing": "العرض التوضيحي لا يرسل شيئاً",
  "no mobile number on file": "لا رقم جوال في الملف",
  "no email on file": "لا بريد في الملف",
  "no SMS provider is set up": "لا مزوّد رسائل نصية مُعد",
  "no email provider is set up": "لا مزوّد بريد مُعد",
  "Requests and changes are made on the system, and every answer, approval or update is sent to the person by SMS and email to the contacts on file. People check in and out by face recognition reader, fingerprint reader or their phone inside a designated location — which one is HR's decision in each staff file, by where they work, their job and access to restricted areas.":
    "تُقدَّم الطلبات والتغييرات على النظام، ويُرسل كل رد أو موافقة أو تحديث إلى الشخص برسالة نصية وبريد إلى وسائل الاتصال في ملفه. ويسجّل الموظفون حضورهم وانصرافهم عبر جهاز التعرف على الوجه أو جهاز البصمة أو جوالهم داخل موقع محدد — وتحدد الموارد البشرية الطريقة في ملف كل موظف حسب مكان عمله ووظيفته ودخوله إلى المناطق المقيّدة.",
  "For everybody, on their phone: check in and out inside a designated location (where HR allows the phone), see today's check-ins, and ask HR for leave, a letter or a change — every answer also comes by SMS and email.":
    "للجميع على جوالاتهم: تسجيل الحضور والانصراف داخل موقع محدد (حيث تسمح الموارد البشرية بالجوال)، ورؤية سجلات اليوم، وطلب إجازة أو خطاب أو تغيير — ويصل كل رد برسالة نصية وبريد أيضاً.",
  "Every SMS and email owed to people about their requests and changes — received, approved, rejected, issued, status or check-in method changed — whether each channel is set up, what went and what did not and why, and sending again.":
    "كل رسالة نصية وبريد مستحق للموظفين عن طلباتهم والتغييرات — الاستلام والاعتماد والرفض والإصدار وتغيّر الحالة أو طريقة الحضور — وهل كل قناة مُعدة، وما أُرسل وما لم يُرسل ولماذا، وإعادة الإرسال.",
  "Import from spreadsheet": "استيراد من جدول بيانات",
  "Nobody is on the register yet. Bring the staff over from the old system with Import from spreadsheet, or add people one by one.":
    "لا أحد في السجل بعد. انقل الموظفين من النظام القديم عبر «استيراد من جدول بيانات»، أو أضفهم واحداً تلو الآخر.",
  "This is the old Excel format (.xls). Open it in Excel and save it as .xlsx or CSV, then choose it again.":
    "هذه صيغة إكسل القديمة (.xls). افتحها في إكسل واحفظها بصيغة .xlsx أو CSV، ثم اخترها مجدداً.",
  "Choose an Excel (.xlsx) or CSV file.": "اختر ملف إكسل (.xlsx) أو CSV.",
  "The sheet has no rows under its headings.": "لا توجد صفوف تحت العناوين في الجدول.",
  "Import staff from a spreadsheet": "استيراد الموظفين من جدول بيانات",
  "Drop the old system's staff export here, or click to choose it":
    "اسحب ملف الموظفين المصدَّر من النظام القديم إلى هنا، أو انقر لاختياره",
  "Excel (.xlsx) or CSV. The first sheet is read; headings can be in English or Arabic.":
    "إكسل (.xlsx) أو CSV. تُقرأ الورقة الأولى؛ ويمكن أن تكون العناوين بالعربية أو الإنجليزية.",
  "Starting from scratch?": "تبدأ من الصفر؟",
  "Download the template, fill one row per person, and bring it back here.":
    "نزّل النموذج، واملأ صفاً لكل شخص، ثم أعده إلى هنا.",
  "Only the employee number, name, nationality and hire date are needed; every other column is optional. Leave balances from the old system can be brought across too.":
    "المطلوب فقط رقم الموظف والاسم والجنسية وتاريخ التعيين؛ وبقية الأعمدة اختيارية. ويمكن نقل أرصدة الإجازات من النظام القديم أيضاً.",
  "{file}: {n} rows under the headings on row {h}. Columns we recognized are matched; check them, and change or leave out any.":
    "{file}: {n} صفاً تحت العناوين في الصف {h}. طابقنا الأعمدة التي عرفناها؛ راجعها، وغيّر أو استبعد ما تشاء.",
  "Column in the file": "العمود في الملف",
  "First values": "أولى القيم",
  "Goes into": "يُدخل في",
  "column {n}": "العمود {n}",
  "— not imported —": "— لا يُستورد —",
  "Still needed: {fields}.": "ما زال مطلوباً: {fields}.",
  "Pay columns are left out: your level cannot change pay.": "استُبعدت أعمدة الرواتب: مستواك لا يسمح بتغيير الرواتب.",
  "Pay will be imported. Only people with the pay permission will see it.":
    "ستُستورد الرواتب. ولن يراها إلا من لديه صلاحية الرواتب.",
  "Choose another file": "اختر ملفاً آخر",
  "The platform is reading every row…": "المنصة تقرأ كل صف…",
  "will be added": "سيُضافون",
  "will be updated": "سيُحدَّثون",
  "already up to date or skipped": "محدَّثون مسبقاً أو متجاوَزون",
  "cannot be imported": "لا يمكن استيرادهم",
  "Update people already on the register (matched by employee number)": "حدّث الموجودين في السجل (بمطابقة رقم الموظف)",
  "Nothing has been saved yet. Nobody is sent an SMS or email by an import.":
    "لم يُحفظ شيء بعد. ولا يُرسل الاستيراد أي رسالة نصية أو بريد لأحد.",
  "Import {n} people": "استورد {n} شخصاً",
  "Back to the columns": "العودة إلى الأعمدة",
  "Save the problem rows": "احفظ الصفوف ذات المشكلات",
  "{a} added and {u} updated. {f} rows could not be imported.": "أُضيف {a} وحُدّث {u}. وتعذّر استيراد {f} صفاً.",
  "See the workforce": "اعرض القوى العاملة",
  "Every row reads cleanly.": "كل الصفوف مقروءة دون مشكلات.",
  "row {n}": "الصف {n}",
  "not imported": "لم يُستورد",
  "imported, with a note": "استُورد مع ملاحظة",
  "Contract charge a month": "رسم المقاول الشهري",
  "Medical premium a year": "قسط التأمين الطبي السنوي",
  "ID / iqama number": "رقم الهوية / الإقامة",
  "Emergency contact mobile": "جوال جهة الطوارئ",
  "Sign-in email (links the login)": "بريد الدخول (يربط الحساب)",
  "Leave balance (days)": "رصيد الإجازات (أيام)",
  "Check-in method": "طريقة تسجيل الحضور",
  "Import staff": "استيراد الموظفين",
  "From the old system's spreadsheet": "من جدول بيانات النظام القديم",
  "Choose the file": "اختر الملف",
  "Match the columns": "طابق الأعمدة",
};
export default ar;
